export const Contact = () => {
    return <div className="flex flex-col">
        <div className="pl-4 font-nobel text-[32px] font-bold">
            Contact
        </div>
        <div className="pl-4 text-[20px] font-normal mt-4">
            Reach us at <a href="mailto:aratta@gmail.com">arratalearn@gmail.com</a> for help or feedback.
        </div>
    </div>;
}